import { render, staticRenderFns } from "./OpticalRnd.vue?vue&type=template&id=46efb04b&scoped=true&"
import script from "./OpticalRnd.vue?vue&type=script&lang=js&"
export * from "./OpticalRnd.vue?vue&type=script&lang=js&"
import style0 from "./OpticalRnd.vue?vue&type=style&index=0&id=46efb04b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46efb04b",
  null
  
)

export default component.exports